import { PAYROLL_ADJ_ALL, PAYROLL_ADJ_POST, PAYROLL_ADJ_LOADING, PAYROLL_ADJ_ERROR } from '../../actions/types';

const initialState = { rows: [], isLoading: false };

export default function PayrollAdjustmentReducer(state = initialState, action) {
  switch (action.type) {
    case PAYROLL_ADJ_ALL:
      return { ...state, rows: action.payload.rows || [], isLoading: false };
    case PAYROLL_ADJ_POST: {
      const updated = action.payload;
      const exists = state.rows.find((r) => r._id === updated._id);
      const rows = exists
        ? state.rows.map((r) => (r._id === updated._id ? updated : r))
        : [...state.rows, updated];
      return { ...state, rows, isLoading: false };
    }
    case PAYROLL_ADJ_LOADING:
      return { ...state, isLoading: true };
    case PAYROLL_ADJ_ERROR:
      return { ...state, isLoading: false };
    default:
      return state;
  }
}
